var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Van1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 20.8V16C35.2 15.1168 35.9168 14.4 36.8 14.4H42.9712L42.4304 13.1392C41.9264 11.9632 40.7696 11.2 39.4896 11.2H4.79998C3.03198 11.2 1.59998 12.632 1.59998 14.4V36.7999H6.47998C6.34558 36.1376 6.37118 35.4191 6.61918 34.6783C7.03838 33.4256 8.11518 32.4335 9.39838 32.1215C12.0416 31.4799 14.4 33.4639 14.4 36C14.4 36.2736 14.3712 36.5408 14.32 36.7999H35.28C35.0576 35.7024 35.2736 34.448 36.2128 33.1984C36.336 33.0816 36.4688 32.9568 36.5936 32.8384C39.8032 30.7087 43.2 32.9568 43.2 36C43.2 36.2736 43.1712 36.5408 43.12 36.7999H46.4V25.6C46.4 23.832 44.968 22.4 43.2 22.4H36.8C35.9168 22.4 35.2 21.6832 35.2 20.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 32C38.1391 32 37.1217 32.4214 36.3716 33.1716C35.6214 33.9217 35.2 34.9391 35.2 36C35.2 37.0609 35.6214 38.0783 36.3716 38.8284C37.1217 39.5786 38.1391 40 39.2 40C40.2609 40 41.2783 39.5786 42.0284 38.8284C42.7786 38.0783 43.2 37.0609 43.2 36C43.2 34.9391 42.7786 33.9217 42.0284 33.1716C41.2783 32.4214 40.2609 32 39.2 32Z",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 32C9.33916 32 8.32174 32.4214 7.5716 33.1716C6.82145 33.9217 6.40002 34.9391 6.40002 36C6.40002 37.0609 6.82145 38.0783 7.5716 38.8284C8.32174 39.5786 9.33916 40 10.4 40C11.4609 40 12.4783 39.5786 13.2285 38.8284C13.9786 38.0783 14.4 37.0609 14.4 36C14.4 34.9391 13.9786 33.9217 13.2285 33.1716C12.4783 32.4214 11.4609 32 10.4 32Z",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 35.2H4.79998M44.8 35.2H46.4H44.8Z",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Van1);
export default __webpack_public_path__ + "static/media/icons8-van 1.2e94ac792c25debf9b3db0dd507b19f1.svg";
export { ForwardRef as ReactComponent };